<template>
  <div>
    <Templates />
  </div>
</template>
<script>
import Templates from "./components/Templates";
export default {
  components: {
    Templates,
  },
};
</script>
